import { render, staticRenderFns } from "./ProjectManageDetail.vue?vue&type=template&id=4b21894c&scoped=true&"
import script from "./ProjectManageDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectManageDetail.vue?vue&type=style&index=0&id=4b21894c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b21894c",
  null
  
)

export default component.exports